import { subscribe } from "../events/jQuerySubscription";
export const getFileNameFromPath = (path) => {
    return path.substring(path.lastIndexOf("/") + 1, path.length);
};
export const getExtensionFromFileName = (fileName) => {
    return fileName.substring(fileName.lastIndexOf(".") + 1, fileName.length);
};
export const getNameFromFileName = (fileName) => {
    return fileName.substring(0, fileName.lastIndexOf("."));
};
export const truncate = (fileName, length) => {
    const name = getNameFromFileName(fileName);
    if (name.length > length) {
        return `${name.substring(0, length)}...${getExtensionFromFileName(fileName)}`;
    }
    else {
        return fileName;
    }
};
export const getFormattedSize = (file) => {
    const i = Math.floor(Math.log(file.size) / Math.log(1024));
    const sizes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    return `${(file.size / Math.pow(1024, i)).toFixed(2)} ${sizes[i]}`;
};
export const muteDocumentDragEvent = (event) => {
    return subscribe($(document), event, (e) => {
        e.preventDefault();
        e.stopPropagation();
    });
};
export const getFiles = async (dataTransfer) => {
    if (!(dataTransfer === null || dataTransfer === void 0 ? void 0 : dataTransfer.items))
        return [];
    const entries = [...dataTransfer.items]
        .map((i) => {
        //@ts-ignore
        const getAsEntry = (i.webkitGetAsEntry || i.getAsEntry).bind(i);
        return getAsEntry === null || getAsEntry === void 0 ? void 0 : getAsEntry();
    })
        .filter((e) => !!e);
    const files = await processFileSystemEntries(entries);
    return files;
};
const processFileSystemEntries = async (entries) => {
    const files = await Promise.all(entries.map((e) => {
        return new Promise((resolve) => {
            if (e.isFile)
                e.file((f) => resolve([f]));
            if (e.isDirectory)
                e
                    .createReader()
                    .readEntries(async (subEntries) => resolve(await processFileSystemEntries(subEntries)));
        });
    }));
    return files.flatMap((f) => f);
};
